import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
// 修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  { path: '/', redirect: '/teacher-book' },
  // { path: '/', redirect: '/home' },
  { path: '/home', name: 'home', component: () => import('../pages/home/index.vue') },
  { path: '/login', name: 'login', component: () => import('../pages/login/index.vue') },
  { path: '/user', name: 'user', component: () => import('../pages/user/index.vue') },

  {
    path: '/encryption',
    name: 'encryption',
    component: () => import('../pages/encryption/index.vue')
  },
  // 学生模块

  {
    path: '/studentModel',
    name: 'studentModel',
    meta: {
      parentUrl: 'studentModel'
    },
    component: () => import('../pages/studentModel/index.vue')
  },

  {
    path: '/onlinecourses',
    name: 'onlinecourses',
    meta: {
      parentUrl: 'onlinecourses'
    },
    component: () => import('../pages/onlinecourses/index.vue')
  },
  {
    path: '/onlinecourses/catalogue',
    name: 'onlinecourses-catalogue',
    meta: {
      parentUrl: 'onlinecourses'
    },
    component: () => import('../pages/onlinecourses/catalogue/index.vue')
  },
  {
    path: '/onlinecourses/catalogue-editable',
    name: 'onlinecourses-catalogue-editable',
    meta: {
      parentUrl: 'onlinecourses'
    },
    component: () => import('../pages/onlinecourses/catalogue-editable/index.vue')
  },
  {
    path: '/onlinecourses/detail',
    name: 'onlinecourses-detail',
    meta: {
      parentUrl: 'onlinecourses'
    },
    component: () => import('../pages/onlinecourses/detail/index.vue')
  },
  {
    path: '/onlinecourses/edit',
    name: 'onlinecourses-edit',
    meta: {
      parentUrl: 'onlinecourses'
    },
    component: () => import('../pages/onlinecourses/edit/index.vue')
  },
  {
    path: '/classmanagement',
    name: 'classmanagement',
    meta: {
      parentUrl: 'onlinecourses'
    },
    component: () => import('../pages/classmanagement/index.vue')
  },
  {
    path: '/myCourse',
    name: 'myCourse',
    meta: {
      parentUrl: 'onlinecourses'
    },
    component: () => import('../pages/myCourse/index.vue')
  },
  {
    path: '/bionicPlatform',
    name: 'bionicPlatform',
    meta: {
    },
    component: () => import('../pages/bionicPlatform/index.vue')
  },
  {
    path: '/boutiqueResources',
    name: 'boutiqueResources',
    meta: {
    },
    component: () => import('../pages/boutiqueResources/index.vue')
  },
  {
    path: '/famousTeacher/famousTeacherList',
    name: 'famousTeacherList',
    meta: {
      parentUrl: 'famousTeacherSpace'
    },
    component: () => import('../pages/famousteacher/list.vue')
  },
  {
    path: '/famousTeacher/famousTeacherApply',
    name: 'famousTeacherApply',
    meta: {
      parentUrl: 'famousTeacherSpace'
    },
    component: () => import('../pages/famousteacher/apply.vue')
  },
  {
    path: '/famousTeacher/famousTeacherSpace',
    name: 'famousTeacherSpace',
    meta: {
      parentUrl: 'famousTeacherSpace'
    },
    component: () => import('../pages/famousteacher/space.vue')
  },

  { path: '/resourcePool', name: 'resourcePool', component: () => import('../pages/resourcePool/index.vue') },
  { path: '/fileresources', name: 'fileresources', component: () => import('../pages/fileresources/index.vue') },
  // 添加富文本
  { path: '/onlinecourses/richtext', name: 'richtext', component: () => import('../pages/onlinecourses/catalogue-editable/edit-richtext.vue') },
  // 添加音视频
  { path: '/onlinecourses/mediaAndFile', name: 'mediaAndFile', component: () => import('../pages/onlinecourses/catalogue-editable/edit-video-and-file.vue') },
  // 新建课程
  {
    path: '/onlinecourses/newCourse',
    meta: {
      parentUrl: 'onlinecourses'
    },
    name: 'newCourse', component: () => import('../pages/onlinecourses/newCourse.vue')
  },
  // 添加测验
  { path: '/onlinecourses/test', name: 'test', component: () => import('../pages/onlinecourses/catalogue-editable/edit-test.vue') },
  { path: '/message-page', name: 'messagePage', component: () => import('../pages/user/message-page.vue') },
  { path: '/teacher-book', name: 'teacherBook', component: () => import('../pages/teacher/teacher-book.vue') },
  { path: '/video-detail', name: 'videoDetail',
    meta: {
      parentUrl: 'teacherBook'
    }, component: () => import('../pages/video/video-detail.vue') },
  { path: '/teacher-book-detail', name: 'teacherBookDetail', component: () => import('../pages/teacher/teacher-book-detail.vue') },
  { path: '/help-list', name: 'helpmodule', component: () => import('../pages/helpmodule/help-list.vue') },
  { path: '/question_detail', name: 'questionDetail', component: () => import('../pages/helpmodule/question_detail.vue') },
]
const router = new VueRouter({
  routes // (缩写) 相当于 routes: routes
})

export default router
